import axios from "axios";

const user = JSON.parse( localStorage.getItem('user') )

export const api = axios.create({
    
    baseURL: window.APP_CONFIG.API_URL,
    headers:{
        Authorization: `Bearer: ${user && user.token}`,
        'Content-Type': 'application/json',
    },
})



